// Copyright (c) 2022 Sagacity Solutions Inc. All right reserved.
'use strict'        ;

import HTTP from "./http-server"

export default {
  getPatients: async function (lastFetch = "") {
    let response = await HTTP.get('v1/patients/', { headers: { 'X-LAST-FETCHED': lastFetch } });
    if (response.status == 200) {
      return {
        timestamp: response.headers['X-FETCH-TIMESTAMP'],
        patients: response.data
      };
    }
    throw new Error(response.status);
  },
  storePatient: async function (patient) {
    let response = await HTTP.post('v1/patients/', patient);
    if (response.status == 200) {
      return response.data;
    }
    throw new Error(response.status);
  },
  removePatient: async function (patient) {
    let response = await HTTP.delete(`v1/patients/${patient.ID}/`);
    if (response.status == 200) {
      return true;
    }
    throw new Error(response.status);
  },
  getPatientOverallAdherence: async function (patientID) {
    let response = await HTTP.get(`v1/patients/${patientID}/overall-adherence`)
    if (response.status == 200) {
      return response.data;
    }
    return 0.0;
  },
  getReportHash: async function (patientID) {
    let response = await HTTP.get(`v1/patients/${patientID}/report-key`)
    if (response.status == 200) {
      return response.data;
    }
    return 0.0;
  },
  getAddressbook: async function (patientID) {
    let response = await HTTP.get(`v1/patients/${patientID}/addressbook/`)
    if (response.status == 200) {
      return response.data
    }
    return null
  },
  updateAddressbook: async function (patientID, contacts) {
    let response = await HTTP.put(`v1/patients/${patientID}/addressbook/`, contacts)
    if (response.status == 200) {
      return response.data
    }
    throw new Error(response.status)
  },
}
